// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__8F2cS","footer":"ModalFilter_footer__1h95M"};